import axios from 'axios'
import store from '@/store'
import { message } from 'ant-design-vue'

// create an axios instance
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 50000// request timeout
})
service.defaults.headers.post['Content-Type'] = 'application/json'
// request interceptor
service.interceptors.request.use(config => {
	const headers = config.headers;
	const token = store.getters.token;
	if (token && !headers['token']) {
		headers['token'] = token
	}
	return config
})


// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		if (isResponseTypeOfJson(response)) {
			if(checkRequestSuccess(response.data)) {
				console.log(response.data)
				return response.data
			} else {
				return handleApiError(response.data)
			}
		} else {
			return response
		}
	},error => {
		console.log('err: ' + error) // for debug
		message.error('出错了，请重新登录或联系管理员')
		return Promise.reject(error)
	}
)

function isResponseTypeOfJson (response) {
	const headers = response.headers
	return headers != null && headers['content-type'] && headers['content-type'].startsWith('application/json')
}

// 判断是否请求成功
export function checkRequestSuccess (res) {
	return res.code === 1
}

// 请求失败处理 10108->无效令牌 10109->token过期 todo 后期要做成刷新token
const handleApiError = data => {
	message.error(data.msg || 'Error')
	if (data && data.code && (data.code === 10108 || data.code === 10109)) {
		store.dispatch('CLEAN_USER_INFO').then(() => {
			setTimeout(() => {
				window.location.reload()
			}, 1000)
		})
	}
	const error = new Error(data.msg || 'Error');
	error.resolved = true;
	return Promise.reject(error)
}

// 默认的响应处理器
const defaultResponseHandler = {
	// 判断是否请求成功
	checkRequestSuccess: checkRequestSuccess,
	// 成功消息提示
	successMessage: true,
	// 成功时的处理函数
	onSuccess (res) {
	},
	// 失败消息提示
	failMessage: true,
	// 失败时的处理函数
	onFail (res) {
	},
	// 错误消息提示
	errorMessage: true,
	// 错误时的处理函数
	onError (e) {
	},
	// 最终的执行函数
	onFinally () {
	}
}

/**
 * 请求方法封装
 * @param request promise
 * @param userResponseHandler 用户设置的 userResponseHandler
 */
export function doRequest (request, userResponseHandler) {
	const handler = Object.assign({}, defaultResponseHandler, userResponseHandler)
	request.then(res => {
		if (handler.checkRequestSuccess(res)) {
			handler.successMessage && message.success(res.msg)
			handler.onSuccess(res)
		} else {
			handler.failMessage && message.error(res.msg)
			handler.onFail(res)
		}
	}).catch((e) => {
		// 未被 axios拦截器处理过，则在这里继续处理
		handler.errorMessage && !e.resolved && message.error(e.message || 'error request')
		handler.onError(e)
	}).finally(() => {
			handler.onFinally()
		}
	)
}

export default service
